import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_steps = _resolveComponent("steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_vorversicherungFH = _resolveComponent("vorversicherungFH")!
  const _component_vorschaedenFHVGV = _resolveComponent("vorschaedenFHVGV")!
  const _component_vorschaedenFHVHV = _resolveComponent("vorschaedenFHVHV")!
  const _component_vorschaedenFHHUG = _resolveComponent("vorschaedenFHHUG")!
  const _component_sanierungsfragen = _resolveComponent("sanierungsfragen")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_steps, {
      active: 4,
      items: _ctx.navItems,
      onGotoPage: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goto-page', $event)))
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, { titel: "Angaben zu Vorversicherungen" }),
      (_ctx.vgvsichtbar)
        ? (_openBlock(), _createBlock(_component_vorversicherungFH, {
            key: 0,
            fehler: _ctx.fehler,
            produkt: "vgv"
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      (_ctx.vhvsichtbar)
        ? (_openBlock(), _createBlock(_component_vorversicherungFH, {
            key: 1,
            fehler: _ctx.fehler,
            produkt: "vhv"
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      (_ctx.hugsichtbar)
        ? (_openBlock(), _createBlock(_component_vorversicherungFH, {
            key: 2,
            fehler: _ctx.fehler,
            produkt: "hug"
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ueberschrift, { titel: "Angaben zu Vorschäden" }),
      (_ctx.vgvsichtbar)
        ? (_openBlock(), _createBlock(_component_vorschaedenFHVGV, {
            key: 3,
            fehler: _ctx.fehler,
            produkt: "Wohngebäude"
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      (_ctx.vhvsichtbar)
        ? (_openBlock(), _createBlock(_component_vorschaedenFHVHV, {
            key: 4,
            fehler: _ctx.fehler,
            produkt: "Hausrat"
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      (_ctx.hugsichtbar)
        ? (_openBlock(), _createBlock(_component_vorschaedenFHHUG, {
            key: 5,
            fehler: _ctx.fehler,
            produkt: "Haus- und Grundbesitzerhaftpflicht"
          }, null, 8, ["fehler"]))
        : _createCommentVNode("", true),
      (_ctx.aelterAls30 && _ctx.enthaeltVGV(_ctx.piniaStore.state) && (_ctx.aelterAls50 || _ctx.flachdach))
        ? (_openBlock(), _createBlock(_component_sanierungsfragen, {
            key: 6,
            aelterAls50: _ctx.aelterAls50,
            fehler: _ctx.fehler
          }, null, 8, ["aelterAls50", "fehler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            offset: 4,
            breite: 6
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.nextPage())),
                "data-cy": "submitHistorieDetails"
              }, " Zusammenfassung und Abschluss ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (_ctx.istSichtbar('modalBeitragsaenderung'))
      ? (_openBlock(), _createBlock(_component_Modal, _mergeProps({ key: 0 }, _ctx.modalBeitragsaenderung, {
          onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.wechsleSichtbarkeit('modalBeitragsaenderung')))
        }), null, 16))
      : _createCommentVNode("", true)
  ], 64))
}